export default {
    label: {
        challengesAndOpportunities: 'Challenges & Opportunities',
        drivers: 'Drivers',
        mainstreamAdoption: 'Mainstream Adoption',
        threads: 'Posts'
    }
}
